export const CONTACT_US_SOURCES = {
  SIDEBAR: 'website_left_funnel',
  OVERUSE: 'website_blocked_overuse_user',
  OFFER: 'website_inside_offer',
  HEADER: 'website_offers_up_left',
  HEADER_MOBILE: 'website_upper_mobile_funnel',
  NO_OFFERS: 'website_no_offers',
  ONE_OR_MORE_CLAIMS: 'in_web_one_claim_or_more',
};
